// Home.js
import React, { useState, useEffect, useRef } from 'react';
import StudentRegistration from '../StudentRegistration';
import StudentLogin from '../StudentLogin';
import StudentDashboard from '../components/student/StudentDashboard';
import InstituteRegistration from '../InstituteRegistration';
import InstituteLogin from '../InstituteLogin';
import InstituteDashboard from '../components/institute/InstituteDashboard';
import AdminLogin from '../AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';
import SideMenu from "./SideMenu";
import About from './About';
import Mission from './Mission';
import Terms from './Terms';
import Contact from './Contact';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Button, Container, Row, Col } from 'react-bootstrap';
import SearchResults from './SearchResults';
import InstituteProfile from './InstituteProfile';
import UniversitiesList from './UniversitiesList';









function Home() {
  // --- State for all roles ---
  const [role, setRole] = useState(() => {
  const r = localStorage.getItem('role');
  return r && r !== '' ? r : null;
});

  const [studentView, setStudentView] = useState(() => localStorage.getItem('studentView') || 'register');
  const [instituteView, setInstituteView] = useState(() => localStorage.getItem('instituteView') || 'register');
  const [adminView, setAdminView] = useState(() => localStorage.getItem('adminView') || 'login');

  const navigate = useNavigate();
  const handleProfileUpdate = () => {};

  const [student, setStudent] = useState(() => {
    const saved = localStorage.getItem('student');
    return saved ? JSON.parse(saved) : null;
  });
  const [institute, setInstitute] = useState(() => {
    const saved = localStorage.getItem('institute');
    return saved ? JSON.parse(saved) : null;
  });
  const [admin, setAdmin] = useState(() => {
    const saved = localStorage.getItem('admin');
    return saved ? JSON.parse(saved) : null;
  });

const [courseList, setCourseList] = useState([]);
const [showDropdown, setShowDropdown] = useState(false);
const dropdownRef = useRef(null);

const [showSideMenu, setShowSideMenu] = useState(false);



//for side menu to mobile windows

const [windowWidth, setWindowWidth] = useState(window.innerWidth);

useEffect(() => {
  function handleResize() {
    setWindowWidth(window.innerWidth);
  }
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

 
  // --- Persist changes ---
  useEffect(() => { localStorage.setItem('role', role || ''); }, [role]);
  useEffect(() => { localStorage.setItem('studentView', studentView || ''); }, [studentView]);
  useEffect(() => { localStorage.setItem('instituteView', instituteView || ''); }, [instituteView]);
  useEffect(() => {
  localStorage.setItem('adminView', adminView || 'login');
}, [adminView]);

useEffect(() => {
  fetch('/api/courses/all')
    .then(res => res.json())
    .then(data => setCourseList(data.courses || []));
}, []);


useEffect(() => {
  function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  }
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);




  // --- Student handlers ---
  function handleStudentLogin(studentData) {
    console.log("Received studentData from login:", studentData); // Add this line
    setStudent(studentData);
    setStudentView('dashboard');
    localStorage.setItem('student', JSON.stringify(studentData));
    setRole('student');
    localStorage.setItem('role', 'student');
    localStorage.setItem('studentView', 'dashboard');
  }
  function handleStudentLogout() {
    setStudent(null);
    setStudentView('login');
    localStorage.removeItem('student');
    localStorage.setItem('studentView', 'login');
    setRole(null);
    localStorage.removeItem('role');
    localStorage.removeItem('authToken'); 
  }
  function handleStudentProfileUpdate(updatedStudent) {
    setStudent(updatedStudent);
    localStorage.setItem('student', JSON.stringify(updatedStudent));
  }

  // --- Institute handlers ---
  function handleInstituteLogin(instituteData) {
    setInstitute(instituteData);
    setInstituteView('dashboard');
    localStorage.setItem('institute', JSON.stringify(instituteData));
    setRole('institute');
    localStorage.setItem('role', 'institute');
    localStorage.setItem('instituteView', 'dashboard');
  }
  function handleInstituteLogout() {
    setInstitute(null);
    setInstituteView('login');
    localStorage.removeItem('institute');
    localStorage.setItem('instituteView', 'login');
    setRole(null);
    localStorage.removeItem('role');
    localStorage.removeItem('authToken');
  }
  function handleInstituteProfileUpdate(updatedInstitute) {
    setInstitute(updatedInstitute);
    localStorage.setItem('institute', JSON.stringify(updatedInstitute));
  }

  // --- Admin handlers ---
  function handleAdminLogin(adminData) {
    setAdmin(adminData);
    setAdminView('dashboard');
    localStorage.setItem('admin', JSON.stringify(adminData));
    setRole('admin');
    localStorage.setItem('role', 'admin');
    localStorage.setItem('adminView', 'dashboard');  // <--- ADD THIS LINE!
  }
  function handleAdminLogout() {
  setAdmin(null);
  setAdminView('login');
  setRole(null);
  localStorage.removeItem('admin');
  localStorage.removeItem('role');
    localStorage.setItem('adminView', 'login');
    localStorage.removeItem('authToken');
  navigate("/"); // <--- Add this line!
}

function handleGoHome() {
  setRole(null);
  setStudentView('login');
  setInstituteView('login');
  setAdminView('login');
  setStudent(null);
  setInstitute(null);
  setAdmin(null);
  localStorage.removeItem('role');
  localStorage.removeItem('student');
  localStorage.removeItem('institute');
  localStorage.removeItem('admin');
  localStorage.setItem('studentView', 'login');
  localStorage.setItem('instituteView', 'login');
  navigate("/");
}



  // --- SWITCH ROLE HANDLER for all dashboards ---
  function handleSwitchRole() {
    setRole(null);
    setStudentView('login');
    setInstituteView('login');
    setAdminView('login');
    localStorage.removeItem('role');
    localStorage.removeItem('admin');
  }

  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
function handleSearch() {
  if (searchQuery.trim()) {
    navigate(`/search-results?q=${encodeURIComponent(searchQuery.trim())}`);
  }
}


  return (
  <div style={{ display: "flex", minHeight: "100vh" }}>
    <SideMenu onGoHome={handleGoHome} navigate={navigate} />
        <div style={{ flex: 1, padding: "0", minHeight: "100vh", position: "relative", marginLeft: windowWidth > 750 ? 220 : 0 }}>
         {/* Hamburger menu button for mobile */}
<button
  className="hamburger-btn"
  onClick={() => setShowSideMenu(true)}
  aria-label="Open menu"
>
  &#9776; {/* Unicode for ☰ */}
</button>


{/* Mobile Drawer for SideMenu */}
{showSideMenu && (
  <div className="side-menu-drawer">
    <button
      className="close-drawer-btn"
      onClick={() => setShowSideMenu(false)}
      aria-label="Close menu"
    >
      &times;
    </button>
    {/* Pass a className to SideMenu so we can target it in CSS */}
    <SideMenu className="drawer-sidemenu" onGoHome={handleGoHome} navigate={navigate} />
  </div>
)}
      <Routes>
        {/* Home Page (Role Selection & Auth Flows) */}
        <Route
          path="/"
          element={
            !role ? (
              // --- New Homepage Hero Layout ---
             <div className="home-hero-bg">
  {/* ROLE BUTTONS - Fixed Top Right */}
  <div className="home-hero-roles-fixed">
    <button
      className="home-role-btn student"
      onClick={() => { setRole('student'); setStudentView('login'); }}>
      Student
    </button>
    <button
      className="home-role-btn institute"
      onClick={() => { setRole('institute'); setInstituteView('login'); }}>
      Institute
    </button>
    <button
      className="home-role-btn admin"
      onClick={() => { setRole('admin'); setAdminView('login'); setAdmin(null); }}>
      Admin
    </button>
  </div>

  {/* SEARCH BAR - Centered */}
  <div className="home-hero-search-outer">
    <div className="home-hero-search" ref={dropdownRef} style={{ position: "relative" }}>
      <input
        type="text"
        className="home-search-input"
        placeholder="Search Programmes"
        value={searchQuery}
        onFocus={() => setShowDropdown(true)}
        onChange={(e) => {
          setSearchQuery(e.target.value);
          setShowDropdown(true);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleSearch();
        }}
        autoComplete="off"
      />
      <button className="home-search-btn" onClick={handleSearch}>
        Search
      </button>
      {/* Dropdown */}
      {showDropdown && courseList.length > 0 && (
        <div className="course-dropdown">
          {courseList
            .filter(course =>
              course.toLowerCase().includes(searchQuery.toLowerCase())
            )
            .slice(0, 30)
            .map((course, idx) => (
              <div
                key={idx}
                className="course-dropdown-item"
                onClick={() => {
                  setSearchQuery(course);
                  setShowDropdown(false);
                }}
              >
                {course}
              </div>
            ))}
          {courseList.filter(course =>
            course.toLowerCase().includes(searchQuery.toLowerCase())
          ).length === 0 && searchQuery.trim() !== "" && (
            <div className="course-dropdown-item" style={{ color: "#888" }}>
              No matches. Continue typing...
            </div>
          )}
        </div>
      )}
    </div>
  </div>

 


  {/* Welcome Text Bottom Left */}
  <div className="home-hero-welcome">
    <h1>
      <span style={{ color: "#fff", fontWeight: 700, fontSize: "2.5rem", letterSpacing: "1.5px", textShadow: "0 4px 14px rgba(42,82,152,0.24)" }}>
        Welcome
      </span><br />
      <span style={{ color: "#4bb3fd", fontWeight: 700, fontSize: "2.5rem", letterSpacing: "1.5px", textShadow: "0 4px 14px rgba(42,82,152,0.10)" }}>
        Universities Admission Service
      </span>
    </h1>
  </div>
</div>

            ) : role === "student" ? (
              <Container>
                <div style={{ textAlign: 'right', marginTop: 10 }}>
                 
                 
                </div>
                {studentView === 'register' && <StudentRegistration setStudentView={setStudentView} />}

                {studentView === 'login' && (
  <StudentLogin onLogin={handleStudentLogin} setStudentView={setStudentView} />
)}

                {studentView === 'dashboard' && (
                  <StudentDashboard
                    student={student}
                    onProfileUpdate={handleProfileUpdate}
                    onLogout={handleStudentLogout}
                    onSwitchRole={handleSwitchRole}
                  />
                )}
              </Container>
            ) : role === "institute" ? (
              <Container>
               
                {instituteView === 'register' && (
  <InstituteRegistration
    onRegistered={(inst) => {
      setInstitute(inst);
      setInstituteView('dashboard');
      localStorage.setItem('institute', JSON.stringify(inst));
      setRole('institute');
      localStorage.setItem('role', 'institute');
      localStorage.setItem('instituteView', 'dashboard');
    }}
    setInstituteView={setInstituteView}
  />
)}

              {instituteView === 'login' && (
  <InstituteLogin
    onLogin={(inst) => {
      setInstitute(inst);
      setInstituteView('dashboard');
      localStorage.setItem('institute', JSON.stringify(inst));
      setRole('institute');
      localStorage.setItem('role', 'institute');
      localStorage.setItem('instituteView', 'dashboard');
    }}
    setInstituteView={setInstituteView}  // <-- add this prop
  />
)}

                {instituteView === 'dashboard' && (
                  <InstituteDashboard
                    institute={institute}
                    onProfileUpdate={handleProfileUpdate}
                    onLogout={handleInstituteLogout}
                    onSwitchRole={handleSwitchRole}
                  />
                )}
              </Container>
            ) : role === "admin" ? (
              adminView === 'login' ? (
                <AdminLogin onLogin={handleAdminLogin} onSwitchRole={handleSwitchRole} />
              ) : (
                <AdminDashboard admin={admin} onLogout={handleAdminLogout} onSwitchRole={handleSwitchRole} />
              )
            ) : null
          }
        />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/about" element={<About />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/institute/:id" element={<InstituteProfile />} />
        <Route path="/universities" element={<UniversitiesList />} />

      </Routes>
    </div>
  </div>
);

}

export default Home;
